import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitCoveragePage } from '@/loaders/unit.coverage.loader';
import { UnitCoveragePage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/coverage';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/coverage/')({
  component: UnitCoveragePage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitCoveragePage,
});
